import { BlockReference } from '@/cms/types/block';
import { BlockComponentModel } from '@/cms/types/blok-component';
import ScrapingTemplatesPreview, { ScrapingTemplatesPreviewProps } from '.';

const ScrapingTemplatesPreviewStrapi = (
  props: BlockComponentModel<{
    scraping_template_preview: BlockReference<ScrapingTemplatesPreviewProps>;
  }>
) => {
  return (
    <ScrapingTemplatesPreview
      {...props.block.scraping_template_preview.data?.attributes}
      {...props}
    />
  );
};

export default ScrapingTemplatesPreviewStrapi;
